export default __webpack_public_path__ + "static/media/circle_outline.31640e9f.svg";